import React from 'react';

import './IconStand.module.scss';
import Circles from '../../../../icons/circles.svg';

const IconStand = ({ children, size = 100, iconBackgroundColor: fill }) => (
  <div aria-hidden="true" styleName="icon-stand" style={{ width: size, height: size }}>
    <Circles styleName="circles" style={{ fill, width: size, height: size }} />
    <div styleName="icon">{children}</div>
  </div>
);

export default IconStand;
